var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#3d828f"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.334 32.3344V17.3344C32.334 16.8761 32.1708 16.4837 31.8444 16.1573C31.518 15.8309 31.1257 15.6677 30.6673 15.6677H17.334C16.8757 15.6677 16.4833 15.8309 16.1569 16.1573C15.8305 16.4837 15.6673 16.8761 15.6673 17.3344V27.3344C15.6673 27.7927 15.8305 28.1851 16.1569 28.5115C16.4833 28.8379 16.8757 29.0011 17.334 29.0011H29.0007L32.334 32.3344Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatButton);
export default __webpack_public_path__ + "static/media/chat-button.6b3a1894ca8d4e266b14fb64ac1942c6.svg";
export { ForwardRef as ReactComponent };